import {
  FormlyButtonComponent,
  FormlyCurrencyFieldComponent,
  FormlyCustomCheckboxListComponent,
  FormlyCustomRadioListComponent,
  FormlyDateInputComponent,
  FormlyDatepickerComponent,
  FormlyInputFieldComponent,
  FormlyLtvFieldComponent,
  FormlyMultiFieldComponent,
  FormlyRadioListComponent,
  FormlyRepeatComponent,
  FormlySelectFieldComponent,
  FormlyTemplateComponent,
  FormlyTypeaheadComponent,
  FormlyWorkIncomeRepeatComponent,
} from './fields';
import {
  FormlyAnimationWrapperComponent,
  FormlyCollapseWrapperComponent,
  FormlyFormFieldWrapperComponent,
  FormlyHeaderWrapperComponent,
  FormlyHorizontalWrapperComponent,
  FormlyTableRowWrapperComponent,
} from './wrappers';

export * from './formly-config';
export * from './models';

export const formlyComponents = [
  // Custom fields
  FormlyButtonComponent,
  FormlyCurrencyFieldComponent,
  FormlyMultiFieldComponent,
  FormlyCustomRadioListComponent,
  FormlyCustomCheckboxListComponent,
  FormlyDateInputComponent,
  FormlyDatepickerComponent,
  FormlyInputFieldComponent,
  FormlyLtvFieldComponent,
  FormlyRadioListComponent,
  FormlyRepeatComponent,
  FormlySelectFieldComponent,
  FormlyTemplateComponent,
  FormlyTypeaheadComponent,
  FormlyWorkIncomeRepeatComponent,

  // Wrappers
  FormlyAnimationWrapperComponent,
  FormlyCollapseWrapperComponent,
  FormlyHeaderWrapperComponent,
  FormlyHorizontalWrapperComponent,
  FormlyTableRowWrapperComponent,
  FormlyFormFieldWrapperComponent,
];
